/* tslint:disable */
/* eslint-disable */
/**
 * Zalaris Benchmarks AI Configuration API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * AI connection configuration containing provider and endpoint settings
 */
export interface AiConfiguration {
    'id'?: string;
    /**
     * AI configuration name for displaying in FE.
     */
    'name'?: string;
    'provider': AiProvider;
    /**
     * API endpoint URL (for Azure OpenAI)
     */
    'endpoint'?: string;
    /**
     * API version (for Azure OpenAI)
     */
    'apiVersion'?: string;
    /**
     * API key (encrypted when stored)
     */
    'apiKey'?: string;
    /**
     * Whether an API key is configured
     */
    'hasApiKey'?: boolean;
}


export interface AiConnectionTestResult {
    /**
     * Whether the connection test was successful
     */
    'success': boolean;
    /**
     * Descriptive message about the test result
     */
    'message': string;
}
export interface AiPrompt {
    'id'?: string;
    /**
     * Human-readable name for this prompt
     */
    'name': string;
    /**
     * Optional description of what this prompt does
     */
    'description'?: string;
    'useCase': AiPromptUseCase;
    /**
     * Model identifier (e.g., gpt-4, gpt-4o, gpt-3.5-turbo)
     */
    'model': string;
    /**
     * Sampling temperature (0.0-2.0). Omit to use provider default.
     */
    'temperature'?: number;
    /**
     * Nucleus sampling parameter (0.0-1.0). Omit to use provider default.
     */
    'topP'?: number;
    /**
     * Maximum tokens in response
     */
    'maxTokens': number;
    /**
     * System prompt (static, not rendered with templates)
     */
    'systemPrompt': string;
    /**
     * User prompt template (Handlebars syntax)
     */
    'userPrompt': string;
}


export interface AiPromptPlaygroundMetadata {
    /**
     * Model used for the test
     */
    'model'?: string;
    'provider'?: AiProvider;
    /**
     * Response time in milliseconds
     */
    'responseTimeMs'?: number;
    /**
     * Tokens consumed (if available from provider)
     */
    'tokensUsed'?: number | null;
}


export interface AiPromptPlaygroundRequest {
    'prompt': AiPrompt;
    /**
     * Position code to test against
     */
    'positionCode': string;
    /**
     * AI configuration ID to use for the test
     */
    'aiConfigId': string;
}
export interface AiPromptPlaygroundResult {
    /**
     * Server-side rendered user prompt (Handlebars substitutions applied)
     */
    'renderedUserPrompt': string;
    /**
     * Raw AI response from the model
     */
    'aiResponse': string | null;
    'mappingResult': JacksonMappingResult;
    'metadata'?: AiPromptPlaygroundMetadata;
}
/**
 * The use case for which this prompt is designed
 */

export const AiPromptUseCase = {
    PositionEnrichment: 'position-enrichment',
    BenchmarkGeneration: 'benchmark-generation'
} as const;

export type AiPromptUseCase = typeof AiPromptUseCase[keyof typeof AiPromptUseCase];



export const AiProvider = {
    Openai: 'openai',
    AzureOpenai: 'azure-openai'
} as const;

export type AiProvider = typeof AiProvider[keyof typeof AiProvider];


export interface ErrorEntry {
    'code'?: string;
    'message'?: string;
}
/**
 * Generic error envelope used across services
 */
export interface ErrorResponse {
    'status'?: number;
    'timestamp'?: string;
    'path'?: string;
    'errors'?: Array<ErrorEntry>;
}
export interface JacksonMappingError {
    /**
     * Error message from Jackson
     */
    'message'?: string;
    /**
     * Error type (e.g., \"JsonMappingException\", \"JsonProcessingException\")
     */
    'type'?: string;
    /**
     * JSON path where error occurred (if available)
     */
    'path'?: string | null;
    /**
     * Detailed error information
     */
    'details'?: string | null;
}
export interface JacksonMappingResult {
    /**
     * Whether Jackson successfully mapped the response to the target DTO
     */
    'success': boolean;
    /**
     * Mapped DTO (only present if success is true)
     */
    'mappedObject'?: { [key: string]: any; } | null;
    'error'?: JacksonMappingError;
}

/**
 * AIConfigurationApi - axios parameter creator
 */
export const AIConfigurationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new AI configuration
         * @param {AiConfiguration} aiConfiguration 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAiConfiguration: async (aiConfiguration: AiConfiguration, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aiConfiguration' is not null or undefined
            assertParamExists('createAiConfiguration', 'aiConfiguration', aiConfiguration)
            const localVarPath = `/api/ai/config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aiConfiguration, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete an AI configuration
         * @param {string} id Unique identifier of the AI configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAiConfiguration: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteAiConfiguration', 'id', id)
            const localVarPath = `/api/ai/config/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a specific AI configuration
         * @param {string} id Unique identifier of the AI configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAiConfiguration: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAiConfiguration', 'id', id)
            const localVarPath = `/api/ai/config/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all AI configurations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAiConfigurations: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ai/config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Test a specific AI configuration
         * @param {string} id Unique identifier of the AI configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testAiConfiguration: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('testAiConfiguration', 'id', id)
            const localVarPath = `/api/ai/config/{id}/test`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an AI configuration
         * @param {string} id Unique identifier of the AI configuration
         * @param {AiConfiguration} aiConfiguration 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAiConfiguration: async (id: string, aiConfiguration: AiConfiguration, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateAiConfiguration', 'id', id)
            // verify required parameter 'aiConfiguration' is not null or undefined
            assertParamExists('updateAiConfiguration', 'aiConfiguration', aiConfiguration)
            const localVarPath = `/api/ai/config/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aiConfiguration, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AIConfigurationApi - functional programming interface
 */
export const AIConfigurationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AIConfigurationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new AI configuration
         * @param {AiConfiguration} aiConfiguration 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAiConfiguration(aiConfiguration: AiConfiguration, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AiConfiguration>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAiConfiguration(aiConfiguration, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AIConfigurationApi.createAiConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete an AI configuration
         * @param {string} id Unique identifier of the AI configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAiConfiguration(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAiConfiguration(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AIConfigurationApi.deleteAiConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a specific AI configuration
         * @param {string} id Unique identifier of the AI configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAiConfiguration(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AiConfiguration>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAiConfiguration(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AIConfigurationApi.getAiConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List all AI configurations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAiConfigurations(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AiConfiguration>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAiConfigurations(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AIConfigurationApi.listAiConfigurations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Test a specific AI configuration
         * @param {string} id Unique identifier of the AI configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testAiConfiguration(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AiConnectionTestResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testAiConfiguration(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AIConfigurationApi.testAiConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update an AI configuration
         * @param {string} id Unique identifier of the AI configuration
         * @param {AiConfiguration} aiConfiguration 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAiConfiguration(id: string, aiConfiguration: AiConfiguration, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AiConfiguration>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAiConfiguration(id, aiConfiguration, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AIConfigurationApi.updateAiConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AIConfigurationApi - factory interface
 */
export const AIConfigurationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AIConfigurationApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new AI configuration
         * @param {AiConfiguration} aiConfiguration 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAiConfiguration(aiConfiguration: AiConfiguration, options?: RawAxiosRequestConfig): AxiosPromise<AiConfiguration> {
            return localVarFp.createAiConfiguration(aiConfiguration, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete an AI configuration
         * @param {string} id Unique identifier of the AI configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAiConfiguration(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteAiConfiguration(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a specific AI configuration
         * @param {string} id Unique identifier of the AI configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAiConfiguration(id: string, options?: RawAxiosRequestConfig): AxiosPromise<AiConfiguration> {
            return localVarFp.getAiConfiguration(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all AI configurations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAiConfigurations(options?: RawAxiosRequestConfig): AxiosPromise<Array<AiConfiguration>> {
            return localVarFp.listAiConfigurations(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Test a specific AI configuration
         * @param {string} id Unique identifier of the AI configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testAiConfiguration(id: string, options?: RawAxiosRequestConfig): AxiosPromise<AiConnectionTestResult> {
            return localVarFp.testAiConfiguration(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an AI configuration
         * @param {string} id Unique identifier of the AI configuration
         * @param {AiConfiguration} aiConfiguration 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAiConfiguration(id: string, aiConfiguration: AiConfiguration, options?: RawAxiosRequestConfig): AxiosPromise<AiConfiguration> {
            return localVarFp.updateAiConfiguration(id, aiConfiguration, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AIConfigurationApi - object-oriented interface
 */
export class AIConfigurationApi extends BaseAPI {
    /**
     * 
     * @summary Create a new AI configuration
     * @param {AiConfiguration} aiConfiguration 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createAiConfiguration(aiConfiguration: AiConfiguration, options?: RawAxiosRequestConfig) {
        return AIConfigurationApiFp(this.configuration).createAiConfiguration(aiConfiguration, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete an AI configuration
     * @param {string} id Unique identifier of the AI configuration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteAiConfiguration(id: string, options?: RawAxiosRequestConfig) {
        return AIConfigurationApiFp(this.configuration).deleteAiConfiguration(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a specific AI configuration
     * @param {string} id Unique identifier of the AI configuration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAiConfiguration(id: string, options?: RawAxiosRequestConfig) {
        return AIConfigurationApiFp(this.configuration).getAiConfiguration(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all AI configurations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listAiConfigurations(options?: RawAxiosRequestConfig) {
        return AIConfigurationApiFp(this.configuration).listAiConfigurations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Test a specific AI configuration
     * @param {string} id Unique identifier of the AI configuration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public testAiConfiguration(id: string, options?: RawAxiosRequestConfig) {
        return AIConfigurationApiFp(this.configuration).testAiConfiguration(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an AI configuration
     * @param {string} id Unique identifier of the AI configuration
     * @param {AiConfiguration} aiConfiguration 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateAiConfiguration(id: string, aiConfiguration: AiConfiguration, options?: RawAxiosRequestConfig) {
        return AIConfigurationApiFp(this.configuration).updateAiConfiguration(id, aiConfiguration, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AIPromptApi - axios parameter creator
 */
export const AIPromptApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new AI prompt
         * @param {AiPrompt} aiPrompt 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAiPrompt: async (aiPrompt: AiPrompt, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aiPrompt' is not null or undefined
            assertParamExists('createAiPrompt', 'aiPrompt', aiPrompt)
            const localVarPath = `/api/ai/prompts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aiPrompt, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete an AI prompt
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAiPrompt: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteAiPrompt', 'id', id)
            const localVarPath = `/api/ai/prompts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a specific AI prompt
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAiPrompt: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAiPrompt', 'id', id)
            const localVarPath = `/api/ai/prompts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all AI prompts
         * @param {AiPromptUseCase} [useCase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAiPrompts: async (useCase?: AiPromptUseCase, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ai/prompts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (useCase !== undefined) {
                localVarQueryParameter['useCase'] = useCase;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an AI prompt
         * @param {string} id 
         * @param {AiPrompt} aiPrompt 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAiPrompt: async (id: string, aiPrompt: AiPrompt, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateAiPrompt', 'id', id)
            // verify required parameter 'aiPrompt' is not null or undefined
            assertParamExists('updateAiPrompt', 'aiPrompt', aiPrompt)
            const localVarPath = `/api/ai/prompts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aiPrompt, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AIPromptApi - functional programming interface
 */
export const AIPromptApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AIPromptApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new AI prompt
         * @param {AiPrompt} aiPrompt 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAiPrompt(aiPrompt: AiPrompt, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AiPrompt>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAiPrompt(aiPrompt, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AIPromptApi.createAiPrompt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete an AI prompt
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAiPrompt(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAiPrompt(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AIPromptApi.deleteAiPrompt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a specific AI prompt
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAiPrompt(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AiPrompt>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAiPrompt(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AIPromptApi.getAiPrompt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List all AI prompts
         * @param {AiPromptUseCase} [useCase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAiPrompts(useCase?: AiPromptUseCase, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AiPrompt>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAiPrompts(useCase, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AIPromptApi.listAiPrompts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update an AI prompt
         * @param {string} id 
         * @param {AiPrompt} aiPrompt 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAiPrompt(id: string, aiPrompt: AiPrompt, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AiPrompt>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAiPrompt(id, aiPrompt, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AIPromptApi.updateAiPrompt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AIPromptApi - factory interface
 */
export const AIPromptApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AIPromptApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new AI prompt
         * @param {AiPrompt} aiPrompt 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAiPrompt(aiPrompt: AiPrompt, options?: RawAxiosRequestConfig): AxiosPromise<AiPrompt> {
            return localVarFp.createAiPrompt(aiPrompt, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete an AI prompt
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAiPrompt(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteAiPrompt(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a specific AI prompt
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAiPrompt(id: string, options?: RawAxiosRequestConfig): AxiosPromise<AiPrompt> {
            return localVarFp.getAiPrompt(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all AI prompts
         * @param {AiPromptUseCase} [useCase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAiPrompts(useCase?: AiPromptUseCase, options?: RawAxiosRequestConfig): AxiosPromise<Array<AiPrompt>> {
            return localVarFp.listAiPrompts(useCase, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an AI prompt
         * @param {string} id 
         * @param {AiPrompt} aiPrompt 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAiPrompt(id: string, aiPrompt: AiPrompt, options?: RawAxiosRequestConfig): AxiosPromise<AiPrompt> {
            return localVarFp.updateAiPrompt(id, aiPrompt, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AIPromptApi - object-oriented interface
 */
export class AIPromptApi extends BaseAPI {
    /**
     * 
     * @summary Create a new AI prompt
     * @param {AiPrompt} aiPrompt 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createAiPrompt(aiPrompt: AiPrompt, options?: RawAxiosRequestConfig) {
        return AIPromptApiFp(this.configuration).createAiPrompt(aiPrompt, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete an AI prompt
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteAiPrompt(id: string, options?: RawAxiosRequestConfig) {
        return AIPromptApiFp(this.configuration).deleteAiPrompt(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a specific AI prompt
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAiPrompt(id: string, options?: RawAxiosRequestConfig) {
        return AIPromptApiFp(this.configuration).getAiPrompt(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all AI prompts
     * @param {AiPromptUseCase} [useCase] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listAiPrompts(useCase?: AiPromptUseCase, options?: RawAxiosRequestConfig) {
        return AIPromptApiFp(this.configuration).listAiPrompts(useCase, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an AI prompt
     * @param {string} id 
     * @param {AiPrompt} aiPrompt 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateAiPrompt(id: string, aiPrompt: AiPrompt, options?: RawAxiosRequestConfig) {
        return AIPromptApiFp(this.configuration).updateAiPrompt(id, aiPrompt, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AIPromptPlaygroundApi - axios parameter creator
 */
export const AIPromptPlaygroundApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Tests an inline AI prompt against a selected position. Returns rendered user prompt, raw AI response, and Jackson mapping result. Results are not persisted. Only userPrompt is rendered with Handlebars. 
         * @summary Test an AI prompt against a position
         * @param {AiPromptPlaygroundRequest} aiPromptPlaygroundRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runPromptPlayground: async (aiPromptPlaygroundRequest: AiPromptPlaygroundRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aiPromptPlaygroundRequest' is not null or undefined
            assertParamExists('runPromptPlayground', 'aiPromptPlaygroundRequest', aiPromptPlaygroundRequest)
            const localVarPath = `/api/ai/prompts/playground`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aiPromptPlaygroundRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AIPromptPlaygroundApi - functional programming interface
 */
export const AIPromptPlaygroundApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AIPromptPlaygroundApiAxiosParamCreator(configuration)
    return {
        /**
         * Tests an inline AI prompt against a selected position. Returns rendered user prompt, raw AI response, and Jackson mapping result. Results are not persisted. Only userPrompt is rendered with Handlebars. 
         * @summary Test an AI prompt against a position
         * @param {AiPromptPlaygroundRequest} aiPromptPlaygroundRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runPromptPlayground(aiPromptPlaygroundRequest: AiPromptPlaygroundRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AiPromptPlaygroundResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runPromptPlayground(aiPromptPlaygroundRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AIPromptPlaygroundApi.runPromptPlayground']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AIPromptPlaygroundApi - factory interface
 */
export const AIPromptPlaygroundApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AIPromptPlaygroundApiFp(configuration)
    return {
        /**
         * Tests an inline AI prompt against a selected position. Returns rendered user prompt, raw AI response, and Jackson mapping result. Results are not persisted. Only userPrompt is rendered with Handlebars. 
         * @summary Test an AI prompt against a position
         * @param {AiPromptPlaygroundRequest} aiPromptPlaygroundRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runPromptPlayground(aiPromptPlaygroundRequest: AiPromptPlaygroundRequest, options?: RawAxiosRequestConfig): AxiosPromise<AiPromptPlaygroundResult> {
            return localVarFp.runPromptPlayground(aiPromptPlaygroundRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AIPromptPlaygroundApi - object-oriented interface
 */
export class AIPromptPlaygroundApi extends BaseAPI {
    /**
     * Tests an inline AI prompt against a selected position. Returns rendered user prompt, raw AI response, and Jackson mapping result. Results are not persisted. Only userPrompt is rendered with Handlebars. 
     * @summary Test an AI prompt against a position
     * @param {AiPromptPlaygroundRequest} aiPromptPlaygroundRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public runPromptPlayground(aiPromptPlaygroundRequest: AiPromptPlaygroundRequest, options?: RawAxiosRequestConfig) {
        return AIPromptPlaygroundApiFp(this.configuration).runPromptPlayground(aiPromptPlaygroundRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



